import { SegmentType } from '../types/serialized-types';
import { BotElement, BotElementType } from '../types/model-types';


class Segment {
    id: string = "";
    description: string | null = null;
    avatarMood: string | null = null;
    elements: BotElement[] = [];

    static fromJSON(obj: SegmentType): Segment {
        let s = new Segment();

        s.id = obj.id;
        s.description = obj.description || null;
        s.avatarMood = obj["avatar-mood"];

        obj.elements.forEach(element => {
            let cls: BotElementType = BotElement.elementClasses[element.type];

            s.elements.push(cls.fromJSON(element));
        });

        return s;
    }
}

export {
    Segment
}
